import React, { PropsWithChildren } from 'react';
import bem from '../../../../lib/bemUtils/bem';

type ElementContainer = PropsWithChildren;

/**
 * Every form element like input, textarea et al should be wrapped in a <p>
 * @param children
 * @constructor
 */
export function ElementContainer({ children }: ElementContainer) {
  return <p className={bem('element-container')}>{children}</p>;
}
